export default {"src":"/_next/static/media/instagram.77054a43.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};